import React from "react";
import "./style.scss";
import "../../components/Dashboard.scss";
import CompanySidebar from "../../components/CompanySidebar";
import {CompanyMain} from "./Main";

const CompanyPrivate = () => {
    return (
        <div className="companyPrivatePage grid">
            <CompanySidebar/>
            <CompanyMain/>
        </div>
    );
};

export default CompanyPrivate;
